const STRING={
   ENTER_NAME: "Please enter your name.",
}
export default STRING;